export const OVERRIDE_PRIMARY_NAV = "OVERRIDE_PRIMARY_NAV";
